
import { PropType, onUnmounted, watch } from 'vue'

export default {
  name: 'ModalComponent',
  props: {
    isModalOpen: Boolean,
    type: String as PropType<'empty'|'popup'|'bottom-sheet'|'card'>,
    closeModal: Function as PropType<() => void>,
    zIndex: {
      type: Number,
      default: 1000
    },
    background: String
  },
  setup (props: any) {
    onUnmounted(() => {
      document.body.style.overflow = 'initial'
    })
    watch(() => props.isModalOpen, () => {
      if (props.isModalOpen) {
        document.body.style.overflow = 'hidden'
      } else {
        document.body.style.overflow = 'initial'
      }
    })
    return {}
  }
}
